<div class="modal fade" id={{modelId}} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            Refund for Booking
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                        data-dismiss="modal">
                </div>
                <hr>
                <div>
                    <div class="modal-text">
                        Do you want to force refund for this booking?
                        <span style="font-weight: bold;">{{data?.reservation_code}}</span><br />
                        This action cannot be undone.
                    </div>

                    <div class="col-md-12 modal-button-div">
                        <div class="row modal-button-row">
                            <button class="btn modal-btn-cancel" type="button" (click)="onAction('No')">No</button>
                            <button class="btn modal-btn-action" type="button" (click)="onAction('Yes')">
                                <span *ngIf="!loading">Yes</span>
                                <div *ngIf="loading" style="position: absolute;">
                                    <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                        type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                                </div>
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>